import React from "react";
import { config } from "./Config";
const apiUrl = config.apiUrl;
const baseUrl = config.baseUrl;

export const LOGIN_URL = apiUrl + "v1/signin";
export const ASSET_URL = config.asset_url;
export const S3_URL = config.s3Url;
export const WIDGET_MESSAGE = apiUrl + "v1/widget-messages";
export const USER_DETAILS = apiUrl + "v1/post-user-details";
export const GET_MESSAGES = apiUrl + "v1/messages";
export const SEND_OTP = baseUrl + "sendOtp";
export const VERIFY_OTP = baseUrl + "verifyOtp";
export const CREATE_ACCOUNT = baseUrl + "client/save";
export const VALIDATE_USER = apiUrl + "v1/validate-user-details";
